export default function (state, getters) {
  if (!state.submitVersionId || !state.versions[state.submitVersionId]) {
    return getters.currentVersion;
  }

  return state.versions[state.submitVersionId];
}
